/*
 Created by CHT 2019/12/4 10:10
*/
import {uuid} from "./utils"
import {
  CHART_CATEGORY__TEXT,
  CHART_TYPE__DEFAULT,
  CHART_TYPE__FILTER_CONTROL, CHART_TYPE__STATISTICS,
  SHORTCUT_BUTTON_TYPE__APPLY_FORM,
  SHORTCUT_BUTTON_TYPE__BIND_WECHAT,
  SHORTCUT_BUTTON_TYPE__OPEN_APP_SET,
  SHORTCUT_BUTTON_TYPE__OPEN_INVITE,
  SHORTCUT_BUTTON_TYPE__OPEN_ORGAN, SHORTCUT_BUTTON_TYPE__OPEN_URL,
  SHORTCUT_BUTTON_TYPE__OPEN_VIEW,
  SHOW_TYPE__DEFAULT, SHOW_TYPE__INDICATOR,
  VISIBLE_TYPE__FOLLOW,
} from "./types"
import {arrayRemove, clone} from "../../assets/js/Untis";

class BaseChart {
  constructor(id) {

    // 是否加载完成
    this.isLoad = true
    // 父级
    this.parent = null
    // 鼠标进入
    this.isHover = false
    // 是否需要先编辑才能放入仪表盘
    this.toEdit = true
    // 用来保存图表数据
    this.value = null
    // 图表展示类型
    this.showType = SHOW_TYPE__DEFAULT

    // 内容确定后回调
    this.toEditCallback = () => {
    }
    // 最小宽
    this.minW = 10
    // 最小高
    this.minH = 3
    // 最大宽
    this.maxW = 60
    // 最大高
    this.maxH = 24

    // 是否 铺满 el-main 修改 header 以及 header 返回按钮
    this.isBespread = false


    this.i = id || uuid('CHART')

    this.chartName = ''
    // 数据源类型
    this.dataSourceType = 'FIXED'
    // 数据源id
    this.dataSourceId = ''
    // 数据源表单名称
    this.dataSourceName = ''

    this.x = 0
    this.y = 0
    this.w = 30
    this.h = 18

    // 是否自动刷新
    this.refreshAuto = 0
    // 自动刷新频率，单位为秒
    this.refreshInterval = 0

    // 可见人员类型
    this.visibleType = VISIBLE_TYPE__FOLLOW
    // 可见人员，指定人员时为userId
    this.visibleFor = []

    // 是否不可见
    this.hidden = 0

    this.miniAppHidden = 0,

    this.chartPropertiesHolder = {}
    // 图表模型相关展示属性，前端定义，后端只做存储回传
    this.showPropertiesHolder = {
      showTitle: 1,
      filterWay: 0,
      legendDes: [], // 图表说明
    }

    this.errorPrompt = '暂无数据'
  }

  get chartId() {
    return this.i
  }
}

// 图表分类
BaseChart.prototype.chartCategory = CHART_CATEGORY__TEXT
// 图表类型
BaseChart.prototype.chartType = CHART_TYPE__DEFAULT

BaseChart.prototype.getBase = function () {
  return {
    chartCategory: this.chartCategory,
    chartType: this.chartType,
    chartShowType: this.showType,

    dataSourceType: this.dataSourceType,
    dataSourceId: this.dataSourceId,
    chartName: this.chartName,
    chartId: this.chartId,

    offsetX: this.x,
    offsetY: this.y,
    width: this.w,
    height: this.h,

    refreshAuto: this.refreshAuto,
    refreshInterval: this.refreshInterval,

    chartPropertiesHolder: this.chartPropertiesHolder,
    showPropertiesHolder: this.showPropertiesHolder
  }
}
BaseChart.prototype.setBase = function (opts) {

  const {
    chartShowType = '',

    dataSourceType,
    dataSourceId,
    chartName,
    chartId,
    hidden,
    miniAppHidden,

    offsetX,
    offsetY,
    width,
    height,

    refreshAuto,
    refreshInterval,

    chartPropertiesHolder,
    showPropertiesHolder
  } = opts

  this.showType = chartShowType

  this.dataSourceType = dataSourceType
  this.dataSourceId = dataSourceId
  this.chartName = chartName
  this.i = chartId
  this.hidden = hidden
  this.miniAppHidden = miniAppHidden

  this.x = offsetX
  this.y = offsetY
  this.w = width
  this.h = height

  this.refreshAuto = refreshAuto || 0
  this.refreshInterval = refreshInterval || 0

  if (!showPropertiesHolder.hasOwnProperty('showTitle')) {
    showPropertiesHolder.showTitle = 1
  }
  if (!showPropertiesHolder.hasOwnProperty('legendDes')) {
    showPropertiesHolder.legendDes = []
  }

  if (this.chartType === CHART_TYPE__STATISTICS && this.showType === SHOW_TYPE__INDICATOR) {
    if (!showPropertiesHolder.hasOwnProperty('optionType')) {
      showPropertiesHolder.optionType = SHORTCUT_BUTTON_TYPE__APPLY_FORM
    }
    if (!showPropertiesHolder.hasOwnProperty('optionContent')) {
      showPropertiesHolder.optionContent = {
        //发起表单
        appId: '',
        formId: "",
        jumpType: 1, // 1跳转视图，2跳转仪表盘
        viewId: "",
        url: "",
        bindType: 0, // 0公众号 1小程序
        inviteType: 0, // 0成员 1外部联系人
      }
    }
    if (!showPropertiesHolder.hasOwnProperty('newPage')) {
      showPropertiesHolder.newPage = 1
    }
    if (!showPropertiesHolder.hasOwnProperty('color')) {
      showPropertiesHolder.color = this.colorOpts[0]
    }
    if (!showPropertiesHolder.hasOwnProperty('customColor')) {
      showPropertiesHolder.customColor = ""
    }
    if (!showPropertiesHolder.hasOwnProperty('icon')) {
      showPropertiesHolder.icon = ""
    }
  }

  Object.assign(this.chartPropertiesHolder, chartPropertiesHolder)
  Object.assign(this.showPropertiesHolder, showPropertiesHolder)

  if(opts.chartType === CHART_TYPE__FILTER_CONTROL) {
    this.value.fixedValue = this.chartPropertiesHolder.fixedValue
    this.value.method = this.chartPropertiesHolder.method
    this.value.value = clone(this.chartPropertiesHolder.value)
    this.value.extValue = this.chartPropertiesHolder.extValue
  }
}
BaseChart.prototype.edit = function () {
  this.parent.editingItem = this
  this.parent.edited = true
}
BaseChart.prototype.remove = function () {
  // 如果是删除筛选器，就需要把对应有筛选联动的筛选器的自己的id去掉
  if (this.chartType === CHART_TYPE__FILTER_CONTROL) {
    const filterControls = this.parent.children.filter(chart => {
      return chart.chartId !== this.chartId && chart.chartType === CHART_TYPE__FILTER_CONTROL
    })
    filterControls.forEach(item => {
      if (item.chartPropertiesHolder.filterGanged.includes(this.chartId)) {
        arrayRemove(item.chartPropertiesHolder.filterGanged, this.chartId)
      }
    })
  }

  this.parent.children.some((item, i) => {
    if (item.i === this.i) {
      this.parent.children.splice(i, 1)
      return true
    } else {
      return false
    }
  })
  this.parent.edited = true
}

BaseChart.prototype.visibleOptionalList = [
  {
    value: VISIBLE_TYPE__FOLLOW,
    label: '同仪表盘'
  }
]

BaseChart.prototype.colorOpts = [
  '#2196F3',
  '#E91E63',
  '#FF9800',
  '#4CAF50',
  '#00BCD4',
  '#3F51B5',
  '#455A64',
  '#63B2EE',
  '#76DA91',
  '#F8CB7F',
  '#7CD6CF',
  '#9192AB',
  '#7898E1',
  '#EFA666',
  '#9987CE'
]

BaseChart.prototype.iconOpts = [
  "iconfont icon-activity",
  "iconfont icon-activity_fill",
  "iconfont icon-addition_fill",
  "iconfont icon-addition",
  "iconfont icon-barrage_fill",
  "iconfont icon-barrage",
  "iconfont icon-browse_fill",
  "iconfont icon-browse",
  "iconfont icon-businesscard_fill",
  "iconfont icon-businesscard",
  "iconfont icon-camera_fill",
  "iconfont icon-camera",
  "iconfont icon-clock_fill",
  "iconfont icon-clock",
  "iconfont icon-collection_fill",
  "iconfont icon-collection",
  "iconfont icon-computer_fill",
  "iconfont icon-computer",
  "iconfont icon-coordinates_fill",
  "iconfont icon-coordinates",
  "iconfont icon-dynamic_fill",
  "iconfont icon-dynamic",
  "iconfont icon-homepage_fill",
  "iconfont icon-homepage",
  "iconfont icon-integral_fill",
  "iconfont icon-integral",
  "iconfont icon-interactive_fill",
  "iconfont icon-interactive",
  "iconfont icon-like_fill",
  "iconfont icon-like",
  "iconfont icon-manage_fill",
  "iconfont icon-manage",
  "iconfont icon-mine",
  "iconfont icon-mine_fill",
  "iconfont icon-praise_fill",
  "iconfont icon-praise",
  "iconfont icon-qrcode_fill",
  "iconfont icon-qrcode",
  "iconfont icon-redpacket_fill",
  "iconfont icon-redpacket",
  "iconfont icon-setup_fill",
  "iconfont icon-setup",
  "iconfont icon-share_fill",
  "iconfont icon-share"
]

BaseChart.prototype.btnOptionTypeOpts = [
  {
    label: '发起表单',
    value: SHORTCUT_BUTTON_TYPE__APPLY_FORM
  },
  {
    label: '打开视图',
    value: SHORTCUT_BUTTON_TYPE__OPEN_VIEW
  },
  {
    label: '打开通讯录',
    value: SHORTCUT_BUTTON_TYPE__OPEN_ORGAN
  },
  {
    label: '打开应用设置',
    value: SHORTCUT_BUTTON_TYPE__OPEN_APP_SET
  },
  {
    label: '邀请成员',
    value: SHORTCUT_BUTTON_TYPE__OPEN_INVITE
  },
  {
    label: '绑定微信',
    value: SHORTCUT_BUTTON_TYPE__BIND_WECHAT
  },
  {
    label: '打开链接',
    value: SHORTCUT_BUTTON_TYPE__OPEN_URL
  }
]

BaseChart.prototype.bindTypeOpts = [
  {
    label: '微信公众号',
    value: 0
  },{
    label: '微信小程序',
    value: 1
  }
]

BaseChart.prototype.inviteTypeOpts = [
  {
    label: '邀请团队成员',
    value: 0
  },{
    label: '邀请外部联系人',
    value: 1
  }
]

export default BaseChart
